export default "__VITE_ASSET__DLK0ldzk__"